<template>
  <div class="course-view">
    <coach-header />
    <course-view :course="course" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import CoachHeader from '@/components/CoachHeader';
import CourseView from '@/components/course/View';

import { FETCH_ONE } from '@/store/course/types';

const { mapActions, mapState } = createNamespacedHelpers('course');

export default {
    computed: {
        ...mapState({
            course: state => (state.course || {}),
        }),
    },
    created() {
        const { id } = this.$route.params;

        this.fetchCourse({
            id,
        });
    },
    methods: {
        ...mapActions({
            fetchCourse: FETCH_ONE,
        }),
    },
    components: {
        CoachHeader,
        CourseView,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/View.vue